import { render, staticRenderFns } from "./articlePreview.vue?vue&type=template&id=c289ab3c&scoped=true&"
import script from "./articlePreview.vue?vue&type=script&lang=js&"
export * from "./articlePreview.vue?vue&type=script&lang=js&"
import style0 from "./articlePreview.vue?vue&type=style&index=0&id=c289ab3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c289ab3c",
  null
  
)

export default component.exports